<template>
  <div class="error-wrap">
    <router-link to="/"><img src="@/assets/images/logo.svg" alt=""></router-link>
    <div class="error-cont">
      <img src="@/assets/images/visual-error.svg" alt="">
      <p>요청하신 페이지를 찾을 수 없습니다.</p>
      <button type="button" class="button__prev" @click="$router.go(-1)">
        <span class="text">
          <i class="icon icon--prev-gray-size16"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss" scoped="scoped">
.error-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 480px;
  height: 420px;
  & > img {
    margin: 0 0 10px 15px;
  }
  .error-cont {
    width: 480px;
    height: 390px;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    text-align: center;
    & > img {
      margin-top: 88px;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #666;
      margin-top: 10px;
    }
    .button__prev {
      position: relative;
      margin-top: 28px;
      display: inline-block;
      width: 38px;
      height: 38px;
      border-radius: 20px;
      border: 1px solid #bbb;
      background: #fff url('../assets/images/icon-page-back.svg') no-repeat center center;
      background-size: 15px 15px;
      min-width: 0;
      padding: 0;
    }
  }
}
</style>
